import { useMutation } from "@apollo/client";
import { CREATE_RESERVATION_INSTANCE } from "../../../../../../../graphql/mutation/ReservationInstance";
import { useFormik } from "formik";
import { Button } from "../../../../../../../components/ui";
import { GridInputs } from "../../../../../../../components/Functional";
import { INSTANCE_STATUS } from "../../../../../../../constants/instanceStatus";
import { FETCH_RESERVATION_INSTANCES_V2 as fetchReservationInstancesV2 } from "../../../../../../../graphql/query/ReservationInstance";

const AddReservationInstanceModal = props => {
  const { closeModal, reservation } = props || {};

  const [createReservationInstance, { loading }] = useMutation(
    CREATE_RESERVATION_INSTANCE({
      instance: {
        edition: {
          artwork: {
            artists: {},
          },
        },
      },
      reservation: {
        reservationInstance: {},
        reservationUser: {},
        type: {},
      },
    }),
    {
      refetchQueries: [
        fetchReservationInstancesV2({
          instance: {
            edition: {
              artwork: {
                artists: {},
              },
            },
          },
          reservation: {
            createdBy: {},
            type: {},
            reservationUser: {},
          },
        }),
      ],
    },
  );

  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,
    onSubmit: async values => {
      createReservationInstance({
        variables: {
          input: {
            reservationId: reservation.id,
            categoryId: reservation.categoryId,
            ...values,
          },
        },
      }).then(resp => {
        const {
          data: { createReservationInstance: { success } = {} },
        } = resp || {};
        if (success) {
          formik.resetForm();
          closeModal();
        }
      });
    },
  });

  const inputs = [
    {
      label: "Instance",
      name: "instanceId",
      type: "instanceSearch",
      defaultStatusIds: [
        reservation?.categoryId === 2
          ? INSTANCE_STATUS.UNCONFIRMED
          : INSTANCE_STATUS.AVAILABLE,
      ],
    },
  ];

  const inputProps = {
    formik,
    inputs,
  };

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex flex-col gap-4 sm:flex-row">
        <div className="flex flex-1 flex-col text-2xl font-bold">
          <div>
            Add instances to{" "}
            {reservation.categoryId === 1 ? "Reservation" : "Make Available"}
          </div>
        </div>
        <div className="flex flex-wrap gap-4">
          <Button
            action="default"
            label="Cancel"
            onClick={() => {
              closeModal();
              formik.resetForm();
            }}
          />
          <Button
            label={"Create"}
            loading={loading}
            disabled={loading}
            onClick={formik.submitForm}
          />
        </div>
      </div>
      <div className="grid">
        <GridInputs {...inputProps} />
      </div>
    </div>
  );
};

export default AddReservationInstanceModal;
